/*** IMPORTS FROM imports-loader ***/
var define = false;

export var FIELD_META_PROP = 'data-__meta';
export var FIELD_DATA_PROP = 'data-__field';



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/form/constants.js
// module id = 596
// module chunks = 0